import React from 'react';
import { NavLink, Link } from 'react-router-dom';

function Bar() {
  const navItems = [
    { path: "/", name: "Home" },
    { path: "/about", name: "About Us" },
    { path: "/service", name: "Services" },
    { path: "/pricing", name: "Pricing" },
    { path: "/projects", name: "Projects" },
    { path: "/contact", name: "Contact" },
  ];

  const getActiveStyle = (isActive) => ({
    color: isActive ? '#b89b6e' : '#e8e1d9',
    borderBottom: isActive ? '2px solid #b89b6e' : '2px solid transparent',
  });

  return (
    <div className="hidden md:block">
      <nav 
        className="flex justify-between items-center h-14 w-full shadow-lg"
        style={{ background: '#2a2118' }}
      >
        <div className="max-w-7xl mx-auto w-full flex justify-between items-center px-6 lg:px-10">
          
          {/* Desktop Navigation */}
          <ul className="flex space-x-1">
            {navItems.map((item, index) => (
              <li key={index}>
                <NavLink
                  to={item.path}
                  style={({ isActive }) => getActiveStyle(isActive)}
                  className="px-5 py-4 text-sm font-medium tracking-wide transition-colors duration-300 inline-block hover:text-[#b89b6e]"
                >
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Question Badge */}
          <Link to="/contact">
            <div 
              className="px-6 py-2 rounded-full text-sm font-semibold shadow-lg 
              hover:shadow-xl transition-all duration-300 cursor-pointer
              text-white"
              style={{ background: '#712B35' }}
              onMouseEnter={(e) => e.target.style.background = '#5f2b40'}
              onMouseLeave={(e) => e.target.style.background = '#712B35'}
            >
              Get a Quote
            </div>
          </Link>
        </div>
      </nav>
    </div>
  );
}

export default Bar;
